import { createGlobalStyle } from "styled-components"

export const StyledCompanyDropdown = createGlobalStyle`
  .company-dropdown-panel .p-dropdown-empty-message {
    display: none !important;
  }
  
  .company-dropdown-panel:has(.p-dropdown-filter:not(:placeholder-shown)) .p-dropdown-empty-message {
    display: list-item !important;
  }
`
export default StyledCompanyDropdown
